<template>
  <div class="p-0 leftBar-dod-wrapper" v-if="!loading">
    <div class="linkBlocks" style="padding-top: 10px !important">
      <router-link
        class="sideButton"
        v-if="this.selectedUser"
        :to="{
          path: '/users/id/' + this.selectedUser.id,
        }"
      >
        <a href="#" class="linkButton">
          <button type="button " class="btn btn-lg link sideButton">
            <div class="d-flex flex-row align-items-center">
              <img src="../icons/profile.svg" />
              <span>Zadania</span>
            </div>
          </button>
        </a>
      </router-link>
      <div class="dod-sidebar-block">
        <strong>DASHBOARD</strong>
        <LeftBarDodElement name="Zadania" section="task" />
        <LeftBarDodElement name="Niepełny grafik" section="customer" />
      </div>
      <div class="dod-sidebar-block">
        <strong>Podopieczni</strong>
        <LeftBarDodElement
          v-for="customerStatus in customerStatuses"
          :key="customerStatus.id"
          :name="customerStatus.name"
          section="customer"
          :status="customerStatus"
        />
      </div>
      <div class="dod-sidebar-block">
        <strong>Opiekunowie</strong>
        <LeftBarDodElement
          v-for="employeeStatus in employeeStatuses"
          :key="employeeStatus.id"
          :name="employeeStatus.name"
          section="employee"
          :status="employeeStatus"
        />
      </div>
    </div>
  </div>
</template>

<script>
import LeftBarDodElement from "../components/LeftBarDodElement.vue";
export default {
  components: { LeftBarDodElement },
  data() {
    return {
      loading: true,
    };
  },
  methods: {
    clearSelectedUser() {
      this.$store.dispatch("setUserToNull");
    },

    copyToClipboard() {
      const el = document.createElement("textarea");
      el.value = this.selectedUser.phone;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
    },
  },
  computed: {
    urlQuery() {
      return this.$route.query;
    },
    selectedUser() {
      return this.$store.getters.getSelectedUser;
    },
    searchError() {
      return this.$store.getters.getSelectedUserError;
    },
    employeeStatuses() {
      return this.$store.getters.getEmployeeStatuses;
    },
    customerStatuses() {
      return this.$store.getters.getCustomerStatuses;
    },
  },
  async created() {
    this.loading = true;
    await this.$store.dispatch("fetchEmployeeStatuses");
    await this.$store.dispatch("fetchCustomerStatuses");
    await this.$store.dispatch("fetchStatusesCounters");
    if (
      this.$route.name === "Customers" &&
      !this.$route.query.status &&
      this.customerStatuses[0]
    ) {
      this.$router.push({
        name: "Customers",
        query: { status: this.customerStatuses[0].id },
      });
      this.$store.dispatch(
        "setSelectedCustomerStatus",
        this.customerStatuses[0]
      );
    }

    if (
      this.$route.name === "Employees" &&
      !this.$route.query.status &&
      this.employeeStatuses[0]
    ) {
      this.$router.push({
        name: "Employees",
        query: { status: this.employeeStatuses[0].id },
      });
      this.$store.dispatch(
        "setSelectedEmployeeStatus",
        this.employeeStatuses[0]
      );
    }
    this.loading = false;
  },

  watch: {
    async urlQuery() {
      if (this.urlQuery && this.urlQuery.status) {
        this.$store.dispatch(
          "setSelectedCustomerStatus",
          this.customerStatuses.find((c) => c.id === this.urlQuery.status)
        );
      }
    },
  },
};
</script>

<style scoped>
.leftBar-dod-wrapper {
  position: sticky;
  height: 84vh;
  overflow-y: auto;
  min-width: 20rem;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.25);
  top: 20px;
}
::-webkit-scrollbar {
  width: 5px;
}
::-webkit-scrollbar-track {
  background: rgb(167, 167, 167);
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  background: #090741;
  border-radius: 10px;
}
.userName {
  font-size: 13px;
  color: rgb(70, 69, 69);
  font-weight: bold;
  text-align: center;
  margin-bottom: 30px !important;
}
.linkBlocks {
  color: #090741;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-items: center;
  position: relative;
  padding: 40px 0 40px 0 !important;
  font-family: "Poppins", sans-serif;
  background: #fff;
  border-radius: 10px;
}
.leftBar i {
  margin-right: 5px !important;
}

button:focus {
  box-shadow: none;
}
button:active,
button:visited,
button:focus {
  background: #f2f2f2 !important;
}
.link {
  font-size: 11px;
  margin-top: 5px;
}
.closeUserPanel {
  margin-top: 30px;
}
.sideButton {
  width: 100%;
  margin: 0 !important;
  margin-bottom: 3px;
  border-radius: 9px;
  font-size: 14px;
  padding: 5px;
}
.sideButton img {
  width: 18px;
  margin-right: 20px;
}

.linkButton:visited {
  background: red;
}
.dod-sidebar-block {
  margin: 10px;
  border-bottom: 1px solid #c1c1cf;
  padding-bottom: 10px;
}

.dod-sidebar-block:nth-last-child(1) {
  border-bottom: unset;
}

.dod-sidebar-block strong {
  display: block;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 10px;
}
@media only screen and (max-width: 1749px) {
  .link {
    font-size: 13px;
    margin-top: 5px;
  }
}
@media only screen and (max-width: 1632px) {
  .link {
    font-size: 13px;
    margin-top: 5px;
  }
}
@media only screen and (max-width: 1515px) {
  .link {
    font-size: 13px;
    margin-top: 5px;
  }
}
@media only screen and (max-width: 1366px) {
  .link {
    font-size: 12px;
    margin-top: 5px;
  }
}
@media only screen and (max-width: 1338px) {
  .link {
    font-size: 11px;
    margin-top: 5px;
  }
}
</style>
